import { PropertyPaneProps } from '@Components/PropertyPane/PropertyPaneProps';
import { createContext, useContext } from 'react';

type MapContextProps = Omit<PropertyPaneProps, 'items'>;

export const MapContext = createContext<MapContextProps>({});

export const useMap = (): MapContextProps => useContext(MapContext);
